/**
 * @name setDataCounter
 * @description [data-num]属性の合計数を取得し、n秒ごとに[data-pos-counter]属性の値を更新する
 * @param {Object} slideLength .mv-slider__list__itemの要素の数
 * @param {Object} docDataPosCounter .data-pos-counterの要素
 * @param {Object} dataNum [data-num]属性の要素
 * @param {Number} intervalTime n秒ごとに[data-pos-counter]属性の値を更新する間隔
 */
export function setDataCounter() {
  let intervalTime = 4000;
  let docDataPosCounter = document.querySelector(".data-pos-counter");
  if (!docDataPosCounter) return;

  const itemClassSetting = (item) => item.dataset.num === docDataPosCounter.dataset.position ? item.classList.add("--active") : item.classList.remove("--active");

  function setDataPosCounter() {
    let slideLength = document.querySelectorAll(".mv-slider__list__item").length.toString();
    let dataNum = document.querySelectorAll(".mv-slider__list__item[data-num]");
    let dataPos = docDataPosCounter.dataset.position;
    dataPos === slideLength ? docDataPosCounter.dataset.position = "1" : docDataPosCounter.dataset.position++;
    dataNum.forEach(item => itemClassSetting(item));
  }

  window.addEventListener("load", () => {
    window.setTimeout(() => {
      setDataPosCounter();
      window.setInterval(() => setDataPosCounter(), intervalTime);
    }, 2000);
  });
};